import PropTypes from 'prop-types';
import React from "react";
import { NavLink } from "react-router-dom";
import { useT } from "~app/BundleProvider";

const Footer = ({ navRef }) => {
  const t = useT();
  return (
    <nav className="Footer" ref={navRef} tabIndex="-1">
      <div className="FooterGroup">
        <NavLink to="/about" className="Footer__nav-link" >
          {t("about")}
        </NavLink>
        <NavLink to="/resources" className="Footer__nav-link">
          {t("educator-resources")}
        </NavLink>
        <NavLink to="/help" className="Footer__nav-link">
          {t("help")}
        </NavLink>
        <NavLink to="/glossary" className="Footer__nav-link">
          {t("glossary")}
        </NavLink>
      </div>
      <div className="FooterGroup FooterLogos">
        <a
          href={t("biointeractive-link")}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={require("~app/resources/images/logos/BiointeractiveLogo.svg")}
            alt="HHMI Biointeractive"
            width="150"
          />
        </a>
        <a
          href="https://undsci.berkeley.edu/"
          target="_blank"
          rel="noopener noreferrer"
          className="Footer__UCMP-logo"
        >
          <img
            src={require("~app/resources/images/logos/UCMPLogo.svg")}
            alt="University of California Museum of Paleontology"
          />
        </a>
      </div>
    </nav>
  );
};

Footer.propTypes = {
  navRef: PropTypes.func.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js